import { RadioGroup, RadioGroupItem } from '@zep-us/zus';
import { useTranslation } from 'next-i18next';
import { cn } from '@/utils/tailwind.util';
import { type QuizBankFilterOption } from '../types';
interface QuizBankGradeFilterProps {
  options: QuizBankFilterOption[];
  /** 단원이 선택돼 있으면 0건 비활성 판정을 하지 않는다 */
  unitFilterApplied?: boolean;
  onSelect: (gradeId: string) => void;
}

/**
 * 학년 필터 — 단수 선택. 0건 학년은 비활성이되 현재 선택은 예외다.
 * 단원이 선택돼 있으면 비활성 판정을 건너뛴다 — 하위 축이 상위 축을 잠그면 안 되고,
 * 학년을 바꾸면 단원 선택이 풀려서 그 카운트는 눌렀을 때의 결과도 아니다.
 */
export const QuizBankGradeFilter = ({
  options,
  unitFilterApplied = false,
  onSelect
}: QuizBankGradeFilterProps) => {
  const {
    t
  } = useTranslation(['build']);
  const selected = options.find(option => option.checked);
  return <section className="flex flex-col gap-3xs" data-sentry-component="QuizBankGradeFilter" data-sentry-source-file="QuizBankGradeFilter.tsx">
      <h3 className="px-2xs text-body-sm-bold text-alternative">
        {t('build:quizBank.filter.grade')}
      </h3>
      <RadioGroup className="flex flex-col gap-none" value={selected?.id} onValueChange={onSelect} data-sentry-element="RadioGroup" data-sentry-source-file="QuizBankGradeFilter.tsx">
        {options.map(option => {
        const disabled = !unitFilterApplied && option.count === 0 && !option.checked;
        return <label key={option.id} className={cn('flex items-center gap-xs rounded-xs px-2xs py-3xs', disabled ? 'cursor-not-allowed text-disabled' : 'cursor-pointer text-default hover:bg-alternative')}>
              <RadioGroupItem value={option.id} disabled={disabled} aria-label={option.label} />
              <span className="min-w-0 flex-1 truncate text-body-md-medium">
                {option.label}
              </span>
            </label>;
      })}
      </RadioGroup>
    </section>;
};